import moment from 'moment';
import { useState } from 'react';
import { IResponseDataBody } from 'services/response';
import appointmentApis from '../services/apis';
import { bookingV2LoadingRef } from './Loading';
type IInquiryCustomerHandler = {
  onStart?: () => void;
  onDone?: (data: string[]) => void;
};
const useQueryAvailableTimeSlotStaff = (handler?: IInquiryCustomerHandler): [({
  data: string[];
}), (date: string, staffId: string) => Promise<void>] => {
  const [timeSlots, setTimeSlots] = useState<string[]>([]);
  const _debounce = async (date: string, staffId: string) => {
    bookingV2LoadingRef.current?.open();
    handler?.onStart?.();
    try {
      const res: IResponseDataBody<string[]> = await appointmentApis.availableTimeSlotStaff(staffId, date);
      const resData = res?.data?.data;
      if (resData) {
        const timeSlots = res.data.data.map(o => moment(o, 'HH:mm').format('hh:mm A'));
        handler?.onDone?.(timeSlots);
        setTimeSlots(timeSlots);
      } else {
        handler?.onDone?.([]);
      }
    } catch (error) {
      handler?.onDone?.([]);
    } finally {
      bookingV2LoadingRef.current?.close();
    }
  };

  return [{ data: timeSlots }, _debounce];
};

export default useQueryAvailableTimeSlotStaff;
